import { Link } from "react-router";

// "Continuă cu Google" (LOT 3): a plain link to the Worker, which sends the browser to Google (OpenID Connect
// with PKCE) and back to /app, or to /login?google=<reason> when it could not sign in.

/** What the sign-in page says for each reason the Worker gives (never technical details). */
export const GOOGLE_MESSAGES: Record<string, string> = {
  cancelled: "Autentificarea cu Google a fost anulată.",
  state: "Sesiunea de autentificare a expirat. Încearcă din nou.",
  token: "Google nu a putut confirma contul. Încearcă din nou.",
  unverified_email: "Adresa de e-mail a contului Google nu este confirmată de Google.",
  account_exists:
    "Există deja un cont Meniova cu această adresă. Intră cu e-mail și parolă, apoi conectează Google din Setări → Cont.",
  registration_closed: "Conturile noi se creează momentan doar prin invitație.",
  disabled: "Contul este dezactivat. Contactează suportul Meniova.",
  admin: "Conturile de administrare Meniova nu folosesc autentificarea cu Google.",
  already_linked: "Acest cont Google este deja conectat la alt cont Meniova.",
};

/** Google's "G" mark (the colours Google asks for on sign-in buttons). */
function GoogleMark() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path
        fill="#EA4335"
        d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
      />
      <path
        fill="#4285F4"
        d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
      />
      <path
        fill="#FBBC05"
        d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
      />
      <path
        fill="#34A853"
        d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
      />
    </svg>
  );
}

export function GoogleButton({ withTerms = false }: { withTerms?: boolean }) {
  return (
    <div className="stack" style={{ gap: 10 }}>
      <a className="btn btn-secondary btn-block" href="/api/auth/google/start">
        <GoogleMark />
        Continuă cu Google
      </a>
      {withTerms && (
        <span className="caption muted">
          Continuând cu Google, accepți <Link to="/termeni">Termenii</Link> și{" "}
          <Link to="/confidentialitate">Nota de confidențialitate</Link> (versiuni de lucru).
        </span>
      )}
      <div className="auth-or" aria-hidden="true">
        <span>sau</span>
      </div>
    </div>
  );
}
